var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { until } from "@vueuse/core";
import { ref } from "vue";
import { stringify } from "lossless-json";
import { useComponentVariable } from "../../component/composables/useComponentVariable";
const areTagsDirty = (tags1, tags2) => {
    return stringify(tags1) !== stringify(tags2);
};
export class ComponentSettingMutable {
    constructor(componentMutableKey, mutableType, setting) {
        this.priority = ref("0");
        this.lastPulledDisplayName = ref(null);
        this.lastPulledDescription = ref(null);
        this.lastPulledTags = ref(null);
        this.lastPulledPriority = ref(null);
        this.mutableType = mutableType;
        this.name = ref(setting.name);
        this.displayName = ref(setting.display_name);
        this.description = ref(setting.description);
        this.type = ref(setting.type);
        this.tags = ref(setting.tags);
        this.priority.value = setting.priority;
        this.context = {
            name: setting.name,
            componentId: setting.context.componentId,
            componentMutableKey,
        };
    }
    getName() {
        return this.context.name;
    }
    getType() {
        return this.type.value;
    }
    setType(type) {
        if (!this.isNew()) {
            return;
        }
        this.type.value = type;
    }
    getDescription() {
        return this.description.value;
    }
    setDescription(description) {
        this.description.value = description;
    }
    getComponentId() {
        return this.context.componentId;
    }
    getComponentMutableKey() {
        return this.context.componentMutableKey;
    }
    getDisplayName() {
        return this.displayName.value;
    }
    setDisplayName(displayName) {
        this.displayName.value = displayName;
    }
    getTags() {
        return this.tags.value;
    }
    setTags(tags) {
        this.tags.value = tags;
    }
    getPriority() {
        return this.priority.value;
    }
    setPriority(priority) {
        this.priority.value = priority;
    }
    isNew() {
        return this.mutableType === "NEW";
    }
    isTranslatable() {
        return false;
    }
    isMultiVariant() {
        return false;
    }
    pull() {
        return __awaiter(this, void 0, void 0, function* () {
            const { componentVariable } = useComponentVariable(this.context.componentId, this.name);
            yield until(componentVariable).not.toBeUndefined();
            if (!componentVariable.value) {
                return;
            }
            this.lastPulledDisplayName.value = componentVariable.value.display_name;
            this.lastPulledPriority.value = componentVariable.value.priority;
            this.lastPulledTags.value = [...componentVariable.value.tags];
            this.lastPulledDescription.value = componentVariable.value.description;
            this.displayName.value = this.lastPulledDisplayName.value;
            this.priority.value = this.lastPulledPriority.value;
            this.tags.value = [...this.lastPulledTags.value];
            this.description.value = this.lastPulledDescription.value;
        });
    }
    isDirty() {
        const isDisplayNameDirty = this.displayName.value !== this.lastPulledDisplayName.value;
        const isPriorityDirty = this.priority.value !== this.lastPulledPriority.value;
        const _areTagsDirty = areTagsDirty(this.tags.value, this.lastPulledTags.value || []);
        const isDescriptionDirty = this.description.value !== this.lastPulledDescription.value;
        return (isDisplayNameDirty ||
            isPriorityDirty ||
            _areTagsDirty ||
            isDescriptionDirty);
    }
    isHtml() {
        return (this.getType() === "STRING" &&
            this.getTags().includes("internal:beta-html"));
    }
}
